import * as Services from "../../Service/Service";
import * as Url from "../../Service/Url";

export const RFPOperationServiceRequest = async (emailId) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.RFPOPERATIONSERVICEREQUEST + emailId,
    null,
    token
  );
  return res;
};

export const RFPApproveRejectServiceRequest = async (
  id,
  emailId,
  IsApproved
) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.RFPOPERATIONAPPROVEREJECTSERVICEREQUEST +
      `RFPserviceRequestId=${id}&ApproveremailId=${emailId}&IsApproved=${IsApproved}`,
    token
  );
  return res;
};

export const GetListOfRFPServiceRequest = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETLISTOFRFPSERVICEREQUEST, token);
  return res;
};

export const GetRFPDetailByUser = async (emailId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETRFPDETAILBYUSER + emailId, token);
  return res;
};

export const GetServiceRequestByUserId = async (emailId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETSERVICEREQUESTBYUSERID + emailId, token);
  return res;
};

// export const GetListOfRFPDetail = async () => {
//   const token = localStorage.getItem("token");
//   let res = await Services.GET(Url.GET_LIST_OF_RFP_DETAILS, token);
//   return res;
// };
export const GetListBidderInfo = async (RfpId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_LIST_BIDDER_INFO + `RfpId=${RfpId}`,
    token
  );
  return res;
};

export const GetListofEmpowerxRfp = async (status,search, pageSize, pageNumber) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_LIST_OF_EMPOWER_RFP +
      `status=${status}&clientName=${search}&pageSize=${pageSize}&pageNumber=${pageNumber + 1}`,
    token
  );
  return res;
};

export const GetRFPDetailById = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETRFPDETAIL + id, token);
  return res;
};

export const RFPOperationCreate = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.RFP_OPERATION_CREATE, payload, token);
  return res;
};

export const RFPOperationUpdate = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.RFP_OPERATION_UPDATE, payload, token);
  return res;
};

export const DeleteRFPDetail = async (id) => {
  const token = localStorage.getItem("token");
  const params = { id };
  let res = await Services.DELETE(Url.RFP_OPERATION_DELETE + id, params, token);
  return res;
};

export const GetEmpoweRxSpecialtyDrugList = async (ClientId, PBMList) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    `${Url.GET_EMPOWERX_SPECIALTY_DRUG_LIST}clientId=${ClientId}&pbmList=${PBMList}`,
    token
  );
  return res;
};
export const GetEmpoweRxSpecialtyDrugListGroup = async (userId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_EMPOWE_RX_SPECIALTY_DRUG_LIST_GROUP + userId,
    token
  );
  return res;
};

export const GetPBMList = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_PBM_LIST, token);
  return res;
};

export const AddEmpowerXSpecialtyDrugLIst = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.SAVE_EMPOWERX_SPECIALTY_DRUG_LIST,
    payload,
    token
  );
  return res;
};

export const DeleteEmpoweRxSpecialtyDrug = async (id) => {
  const token = localStorage.getItem("token");
  const params = { id };
  let res = await Services.DELETE(
    Url.DELETE_EMPOWERRX_SPECIALTY_DRUG + id,
    params,
    token
  );
  return res;
};
export const DeleteEmpoweRxSpecialtyDrugListGroup = async (
  ClientId,
  PBMList
) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(
    `${Url.DELETE_EMPOWER_RX_SPECIALTY_DRUG_LIST_GROUP}clientId=${ClientId}&pbmList=${PBMList}`,
    "",
    token
  );
  return res;
};
export const CreateOrUpdateEmpoweRxDrugDiscount = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.DRUG_EMPOER_RX_OPERATION_CREATEUPDATE,
    payload,
    token
  );
  return res;
};

export const GetEmpoweRxDrugDiscountById = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETEMPOERDETAIL + id, token);
  return res;
};
export const DeleteEmpoweRxDrugDiscount = async (id) => {
  const token = localStorage.getItem("token");
  const params = { id };
  let res = await Services.DELETE(
    Url.DRUG_EMPOER_RX_OPERATION_DELETE + id,
    params,
    token
  );
  return res;
};

export const EmpowerxRfpCreate = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.EMPOWE_RX_RFP_CREATE, payload, token);
  return res;
};
export const EmpowerxRfpUpdate = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.EMPOWE_RX_RFP_UPDATE, payload, token);
  return res;
};
export const EmpowerxRfpDelete = async (ID) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.EMPOWE_RX_RFP_DELETE + ID, "", token);
  return res;
};

export const CreateBidderInfo = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.CREATE_BIDDER_INFO, payload, token);
  return res;
};

export const UpdateBidderInfo = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_BIDDER_INFO, payload, token);
  return res;
};

export const DeleteBidderInfo = async (ID) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_BIDDER_INFO + ID, "", token);
  return res;
};

export const GetEmpoweRxDrugDiscountByClientId = async (clientID) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GETEMPOWERXDRUGDISCOUNTBYCLIENTID + clientID,
    token
  );
  return res;
};

export const GetEmpowerxBidFileRecord = async (
  ClientName,
  StartDate,
  EndDate
) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_EMPOWER_RX_BID_FILE_RECORD +
      `ClientName=${ClientName}&StartDate=${StartDate}&EndDate=${EndDate}`,
    token
  );
  return res;
};

export const SBCAndRxClaimDataFormFileUpload = (
  rfpID,
  SBCFile,
  rxCliamData
) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();

  formData.append("sbcFormFile", SBCFile);
  formData.append("rxClaimDataFormFile", rxCliamData);

  let res = Services.POSTFORMDATA(
    `/api/Empowerx_Rfp/SBCAndRxClaimDataFormFileUpload?rfpId=${rfpID}`,
    formData,
    token
  );
  return res;
};

export const ImportEmpoweRxSpecialtyDrug = (
  clientID,
  ClientName,
  PBMList,
  UserId,
  file
) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("files", file);

  let res = Services.POSTFORMDATA(
    `${Url.IMPORT_EMPOWER_RX_SPECIALTY_DRUG}ClientId=${clientID}&ClientName=${ClientName}&PBMList=${PBMList}&UserId=${UserId}`,
    formData,
    token
  );
  return res;
};

export const SubmitRfp = (rfpID, exsitingBidderInfoCSV, SBCFile) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();

  formData.append("RxClaimDataFile", exsitingBidderInfoCSV);
  formData.append("SBCFormFile", SBCFile);

  let res = Services.POSTFORMDATA(
    `/api/Empowerx_Rfp/SubmitRfp?RfpId=${rfpID}`,
    formData,
    token
  )
  return res;
};

export const AddDataToEmpoweRxSpecialtyDrug = async (
  clientID,
  ClientName,
  PBMList,
  UserId,
  isDeleteExstingRecord
) => {
  const token = localStorage.getItem("token");
  const url = `${Url.ADD_DATA_TO_EMPOWER_RX_SPECIALTY_DRUG}clientId=${clientID}&ClientName=${ClientName}&PBMList=${PBMList}&UserId=${UserId}&isDeleteExstingRecord=${isDeleteExstingRecord}`;
  let res = await Services.POST(url, "", token);
  return res;
};

export const DownloadFile = (FileURL) => {
  const token = localStorage.getItem("token");
  const responseType = "blob";
  let res = Services.GETBINARYDATA(
    `/api/Empowerx_Rfp/DownloadFile?FileURL=${FileURL}`,
      token,
      responseType
  )
  return res;
};

export const DuplicateQuestionnarie = async (
  rfpId,
  surveyID_old,
  surveyID_new
) => {
  const token = localStorage.getItem("token");
  const url = `${Url.DUPLICATE_QUESTIONNARIE}rfpId=${rfpId}&OldSurveyId=${surveyID_old}&NewSurveyID=${surveyID_new}`;
  let res = await Services.POST(url, "", token);
  return res;
};

export const DeleteDuplicateQuestionnaire = async (rfpId,surveyId) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_DUPLICATE_QUESTIONNARIE + `rfpId=${rfpId}&SurveyId=${surveyId}`, "", token);
  return res;
};

export const DrugDiscountFileUpload = (
  DrugId,
  PBMContractFile,
  HospitalHealthSystemFile,
  PBMClaimsFile
) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();

  formData.append("PBMContractFile", PBMContractFile);
  formData.append("HospitalHealthSystemFile", HospitalHealthSystemFile);
  formData.append("PBMClaimsFile",PBMClaimsFile);

  let res = Services.POSTFORMDATA(
    `/api/Empowerx_Rfp/UpdateFileUrlDrugDiscountById?DrugId=${DrugId}`,
    formData,
    token
  )
  return res;
};

export const AddUpdateNewQuestions = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADDUPDATERFPNEWQUESTIONS, payload, token);
  return res;
};

export const GetNewQuestions = async (rfpId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GETRFPNEWQUESTIONS + rfpId,
    token
  );
  return res;
};

export const DeleteNewQuestions = async (ID) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETERFPNEWQUESTIONS + ID, "", token);
  return res;
};

export const GetEmpoweRxDrugDiscountInRfp = async (userId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    `${Url.GETEMPOWERXDRUGDISCOUNTINRFP}userId=${userId}`,
    token
  );
  return res;
};

export const CheckBidFileRecordbyClientName = async (clientName) =>{
  const token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.CHECKBIDFILERECORDBYCLIENTNAME}ClientName=${clientName}`, token);
  return res;
}

export const GetPresignedDrugFileURL = async (DrugId,FileName,FileType) => {
  let res = Services.GET(
    `${Url.GETPRESIGNEDURLDRUDISCOUNTFILE}DrugId=${DrugId}&FileName=${FileName}&&FileType=${FileType}`
  );
  return res;
};
